import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { GiftcardDetailView } from "./component";
import { Product } from "../../../../components/Reusable/type";
import { fetchGiftcardPlans } from "../../../../features/auth/store/giftcardPlanSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import Giftcard from "./Giftcard";
import { fetchGiftcardCategories } from "../../../../features/auth/store/giftcardCategorySlice";

const GiftcardRouter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [selectedGiftcardPlan, setSelectedGiftcardPlan] =
    useState<Product | null>(null);
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { giftcardPlans, loading, error } = useSelector(
    (state: RootState) => state.giftcardPlans,
  );

  const { giftcardCategories } = useSelector(
    (state: RootState) => state.giftcardCategories,
  );

  const isMounted = useRef(false);

  useEffect(() => {
    if (giftcardCategories.length == 0) {
      dispatch(fetchGiftcardCategories({ perPage: 40 }));
    }
  }, []);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      dispatch(fetchGiftcardPlans({}));
      return;
    }
    const handler = setTimeout(() => {
      const filters: Record<string, any> = {};

      if (statusFilter) filters.status = statusFilter;
      if (searchTerm.trim()) filters.search = searchTerm.trim();
      dispatch(fetchGiftcardPlans(filters));
    }, 350);

    return () => clearTimeout(handler);
  }, [dispatch, statusFilter, searchTerm]);

  // Transform GiftcardPlan to Product - ensuring all required fields are present

  const handleGiftcardPlanClick = (giftcardPlan: Product) => {
    setSelectedGiftcardPlan(giftcardPlan);
    setShowDetailView(true);
  };

  const handleBackToList = () => {
    setShowDetailView(false);
    setSelectedGiftcardPlan(null);
  };

  if (showDetailView && selectedGiftcardPlan) {
    return (
      <GiftcardDetailView
        giftcardPlan={{
          ...selectedGiftcardPlan,
        }}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <Giftcard
      giftcardPlans={giftcardPlans || []}
      loading={loading}
      error={error}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onGiftcardPlanClick={handleGiftcardPlanClick}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
    />
  );
};

export default GiftcardRouter;
